import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "delete-dialog-content" }
const _hoisted_2 = { class: "delete-dialog-header" }
const _hoisted_3 = { class: "delete-dialog-body" }
const _hoisted_4 = { class: "delete-dialog-text-group" }
const _hoisted_5 = { class: "delete-dialog-conversation-title" }
const _hoisted_6 = { class: "delete-dialog-actions" }

import { del as idbDel } from 'idb-keyval';

import { type Conversation } from '@/services/conversationService';
import { useConversationStore } from '@/stores/conversationStore';
import { useMessageStore } from '@/stores/messageStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { CACHE_KEYS } from '@/utils/cache';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteConversationDialog',
  props: {
    modelValue: { type: Boolean },
    conversation: {}
  },
  emits: ["update:modelValue", "deleted"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const route = useRoute();
const router = useRouter();
const conversationStore = useConversationStore();
const messageStore = useMessageStore();
const notificationStore = useNotificationStore();

const isDeleting = ref(false);

const confirmDelete = async () => {
  if (!props.conversation) return;

  try {
    isDeleting.value = true;
    await conversationStore.deleteConversationById(props.conversation.id);
    idbDel(CACHE_KEYS.CONVERSATION_METADATA(props.conversation.id));
    messageStore.invalidateConversationMessages(props.conversation.id);
    if (route.params.id === props.conversation.id) {
      router.push('/en/echo');
    }
    emit('update:modelValue', false);
    emit('deleted');
  } catch (error) {
    console.error('Failed to delete conversation:', error);
    notificationStore.notify(
      'Failed to delete conversation. Please try again.',
    );
  } finally {
    isDeleting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "723",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "delete-dialog-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "delete-dialog-title" }, "Delete Chat", -1)),
              _createVNode(_component_v_btn, {
                icon: "",
                size: "40",
                variant: "text",
                class: "delete-dialog-close",
                "aria-label": "Close dialog",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "40",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-close-circle-outline", -1)
                    ])),
                    _: 1,
                    __: [3]
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "delete-dialog-subtitle" }, " Are you sure you want to delete any memories saved during this chat: ", -1)),
                _createElementVNode("p", _hoisted_5, " \"" + _toDisplayString(_ctx.conversation?.title) + "\" ", 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_btn, {
                  class: "delete-dialog-cancel-btn",
                  variant: "outlined",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" Cancel ", -1)
                  ])),
                  _: 1,
                  __: [6]
                }),
                _createVNode(_component_v_btn, {
                  class: "delete-dialog-confirm-btn",
                  loading: isDeleting.value,
                  onClick: confirmDelete
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" Delete ", -1)
                  ])),
                  _: 1,
                  __: [7]
                }, 8, ["loading"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})